import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from '../../../environments/environment';
import { GiftCardDetails } from 'app/application/application';
import { TokenService } from 'app/token/token.service';
import { DeviceDetectService } from 'app/common/device-detect/device-detect.service';
import { AwsTrackingService } from 'app/common/tracking/aws-tracking.service';
import { EventDetails } from '../../common/tracking/aws-tracker';

declare let $;
declare var Materialize: any;

@Component({
  selector: 'zest-voucher-list',
  templateUrl: './voucher-list.component.html',
  styleUrls: ['./voucher-list.component.scss']
})
export class VoucherListComponent implements OnInit {

  @Input() vouchers: GiftCardDetails[];
  @Input() disableCopy: boolean;

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  voucherMerchants: any[] = [];
  allVouchers: boolean;
  s3Url = environment.s3BucketUrl;
  tncMerchant: string;
  isDesktop: boolean;

  constructor(private tokenService: TokenService, private deviceService: DeviceDetectService, private awsTrackingService: AwsTrackingService) { }

  ngOnInit() {
    this.isDesktop = this.deviceService.isDesktop();
    this.voucherMerchants = this.groupVouchersByMerchant(this.vouchers);
    const props = this.awsTrackingService.setGlobalCustomProps();
    const event = new EventDetails('OCDVoucherActivated', 'event', 'triggered');
    this.awsTrackingService.sendDataToFunnelWithCustomProperties(event, props);
  }

  groupVouchersByMerchant(vouchers) {
    const voucherMerchants: any = {};
    const merchantSettings = this.tokenService.getMerchantSettings();

    vouchers.forEach(voucher => {
      const merchantConfig = merchantSettings.find(merchant => merchant.partnerName.toLowerCase() === voucher.merchantName.toLowerCase());
      if (voucherMerchants[voucher.merchantName]) {
        voucherMerchants[voucher.merchantName].totalValue = voucherMerchants[voucher.merchantName].totalValue + voucher.voucherValue;
        voucherMerchants[voucher.merchantName].vouchers.push({
          voucherCode: voucher.voucherCode,
          voucherPin: voucher.voucherPin,
          voucherValue: voucher.voucherValue,
          voucherValidity: voucher.voucherValidity,
          merchantName: voucher.merchantName
        });
      } else {
        voucherMerchants[voucher.merchantName] = {
          merchantName: voucher.merchantName,
          totalValue: voucher.voucherValue,
          isOffline: merchantConfig.isOffline,
          vouchers: []
        };
        voucherMerchants[voucher.merchantName].vouchers.push({
          voucherCode: voucher.voucherCode,
          voucherPin: voucher.voucherPin,
          voucherValue: voucher.voucherValue,
          voucherValidity: voucher.voucherValidity,
          merchantName: voucher.merchantName
        });
      }
    });

    return Object.keys(voucherMerchants).map((merchant => voucherMerchants[merchant]));
  }

  showAllVouchers() {
    this.allVouchers = true;
  }

  copyToClipboard(myString) {
    const el = document.createElement('textarea');
    el.value = myString;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    Materialize.toast('Copied successfully!', 5000, 'rounded', () => { this.tokenService.removeAllToasts(); });
  }

  claimCode(voucher: GiftCardDetails) {
    if (voucher.merchantName.toLowerCase() === 'amazonpay') {
      window.open('https://www.amazon.in/?&_encoding=UTF8&tag=zestmoney-21&linkCode=ur2&linkId=9577f7adc0716e5a8b2c7d4336468f19&camp=3638&creative=24630&claimCode=' + voucher.voucherPin.replace(/-/g, ''), '_blank');
    } else if (voucher.merchantName.toLowerCase() === 'flipkart') {
      window.open('http://fkrt.it/fEnzsbuuuN', '_blank');
    } else {
      this.copyToClipboard(voucher.voucherCode);
    }
  }

  toggleTnCView(state, merchantName) {
    if (state === 'open') {
      this.tncMerchant = merchantName;
    } else {
      this.tncMerchant = '';
    }
    $('#tnc').modal(state);
  }

  closeView() {
    this.close.emit(true);
  }

}
